import { Quote } from "lucide-react";
import { Reveal } from "../lib/motion";

const ABOUT_IMG =
  "https://static.prod-images.emergentagent.com/jobs/dc8a482d-361d-4996-9eb5-a4cbac9ec941/images/19f9da06519951930618277e69f3c35a0e288786f49bd8557a33a04a27d430d1.jpeg";

export const About = () => (
  <section id="about" className="relative bg-[#FAFAF9] py-20 sm:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <Reveal>
        <div className="relative rounded-[2rem] rounded-tr-[4rem] overflow-hidden shadow-xl shadow-[#3B3A4E]/15 aspect-square bg-[#F5F4F1]">
          <img
            src={ABOUT_IMG}
            alt="Illustration of Michael, the Recovery Rides host, introducing a warm, diverse team of adults aged 20s to 50s"
            className="h-full w-full object-cover"
          />
        </div>
      </Reveal>

      <div>
        <Reveal>
          <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-[#0891B2] mb-4">
            About Us
          </p>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#3B3A4E] leading-tight">
            Built by People Who Understand Recovery
          </h2>
        </Reveal>
        <Reveal delay={0.08}>
          <div className="mt-6 space-y-4 text-base sm:text-lg text-[#5C5975] leading-relaxed">
            <p>
              Recovery Rides LLC has been serving the recovery community since 2018. The company was founded in
              South Florida by individuals with firsthand knowledge of substance use disorder, treatment, and
              recovery.
            </p>
            <p>
              We understand the everyday transportation problems faced by providers, staff members,
              individuals, and families because we have experienced these challenges from multiple sides.
            </p>
            <p>
              Our goal is to handle the transportation and concierge needs that consume valuable time and
              resources, allowing treatment and recovery professionals to remain focused on the people
              depending on them.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.14}>
          <figure className="mt-8 relative rounded-3xl bg-[#1F1D2B] p-8 sm:p-9 overflow-hidden">
            <div className="pointer-events-none absolute -top-10 -right-8 h-40 w-40 rounded-full bg-[#1AD1B9]/20 blur-3xl" />
            <Quote size={34} className="text-[#1AD1B9] mb-3" />
            <blockquote className="relative text-lg sm:text-xl font-heading font-medium text-white leading-snug">
              “We believe every person deserves to get where they need to go with dignity, encouragement, and
              someone who understands what the journey means.”
            </blockquote>
          </figure>
        </Reveal>
      </div>
    </div>
  </section>
);
